<template>
  <MapPinIcon class="absolute z-10 cursor-pointer transition stroke-black hover:opacity-50" :class="selected
    ? 'text-green-500 animate-pin-bounce'
    : 'text-red-500 -translate-x-1/2 -translate-y-full'
    " :style="{ left: x + 'px', top: y + 'px', width: size, height: size }" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { MapPinIcon } from '@heroicons/vue/24/solid'

export interface MapPinProps {
  x: number
  y: number
  scale: number
  selected?: boolean
}

const props = withDefaults(defineProps<MapPinProps>(), {})

const size = computed(() => {
  const min = 1
  const max = 5
  const rounded = Math.ceil(max - ((max - min) * props.scale) / 50) // 50 is max zoom

  return `${rounded}px`
})
</script>
